import { useParams } from 'react-router-dom';
import { Page } from 'ui';

import { InspectionDetails } from '../../components/InspectionDetails/InspectionDetails';

export const InspectionShow = () => {
  const { id } = useParams();
  return (
    <Page>
      <InspectionDetails inspectionId={id ? Number(id) : undefined} />
    </Page>
  );
};
